
const m = window.require("embercom/lib/sentry");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
